import placeholderImage from "../../../assets/images/placeholder.jpg"
import {eventTag, validateLinkVideo} from "../../../services/utils"
import {Link} from "react-router-dom"
import Skeleton from "../../skeleton";
import {useEffect, useState} from "react";
import "./index.scss"

function CardSkeletonPill({item}) {
  return (
    <div className="card-pill">
      {
        !item.video ? (
          <h3>
            <Skeleton
              width="100%"
              height="36px"
              style={{ marginBottom: 12 }}
            />
          </h3>
        ) : ''
      }
      <Skeleton
        width="100%"
        height="184px"
        className="image"
      />
    </div>
  )
}

const CardPill = ({item, loading = true, event = {}}) => {
  const [showSkeleton, setShowSkeleton] = useState(loading)

  const CardExternalPill = () => {
    const Layout = (
      <>
        <div className="card-pill__text">
          <h3>
            {item?.title}
          </h3>
          <p>
            {item?.subtitle}
          </p>
        </div>
        <img
          src={item?.image}
          width="286px"
          height="184px"
          alt={item?.title || "Imagem em destaque"}
          className="image"
          loading="lazy"
          onLoad={() => setShowSkeleton(false)}
          onError={() => setShowSkeleton(false)}
        />
      </>
    )
    return (
      <>
        <a
          href={item?.link_mobile}
          target="_blank"
          rel="noreferrer"
          className="card-pill__mobile"
          title={item?.title}
          onClick={() => eventTag(event?.name, event?.category, event?.action, item.title)}>
          { Layout }
        </a>
        <a
          href={item?.link_desktop}
          target="_blank"
          rel="noreferrer"
          className="card-pill__desktop"
          title={item?.title}
          onClick={() => eventTag(event?.name, event?.category, event?.action, item.title)}>
          { Layout }
        </a>
      </>
    )
  }

  useEffect(() => {
    setTimeout(() => {
      setShowSkeleton(false)
    }, 500)
  }, [showSkeleton])

  return showSkeleton ? (<CardSkeletonPill item={item} />) : (
    <div className={`card-pill ${item?.id === 'coletaneas' ? 'right' : ''}`} key={item?.id}>
      {
        item?.id === 'coletaneas' ? (
          <CardExternalPill />
        ) : (
          <Link to={`/pilula/${item.id}`}
                onClick={() => eventTag(event?.name, event?.category, event?.action, item.title)}
                title={item.title}>
            {
              !item.video ? (
                <div className="card-pill__text">
                  <h3>
                    {item.title || ""}
                  </h3>
                  {
                    item.subtitle ? (
                      <p>
                        {item.subtitle}
                      </p>
                    ) : ""
                  }
                </div>
              ) : ''
            }
            {!item.image && !item.video ? (
              <img
                src={placeholderImage}
                width="286px"
                height="184px"
                alt="Imagem em destaque"
                className="image"
                loading="lazy"
                onLoad={() => setShowSkeleton(false)}
                onError={() => setShowSkeleton(false)}
              />
            ) : item.image ? (
              <img
                src={item.image}
                width="286px"
                height="184px"
                alt={item.title || "Imagem em destaque"}
                className="image"
                loading="lazy"
                onLoad={() => setShowSkeleton(false)}
                onError={() => setShowSkeleton(false)}
              />
            ) : (
              <iframe
                src={validateLinkVideo(item.video)}
                width="465px"
                height="261.95px"
                className="video"
                title={item.title || "Video em destaque"}
                style={{ pointerEvents: "none" }}
                loading="lazy"
                onLoad={() => setShowSkeleton(false)}
              />
            )}
          </Link>
        )
      }
    </div>
  )
}

export default CardPill